export const iconFontAwesomeMathematicsEquals = (
	<i className="fa-solid fa-equals"></i>
);
